import { Col, DatePicker, Divider, Form, Input, Row, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  DATE_FORMATS,
  NUMBER_FIELD_TYPES,
  SUBSCRIPTION_TYPE,
} from '../../../../../common/constants';
import { formValidatorRules } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';
import NumberComponent from '../../../../../components/NumberComponent';
import SubscriptionPlanSelect from '../../../../offers/modules/giftCard/components/SubscriptionPlanSelect';

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;
const { whitespaceNotAllowed } = formValidatorRules;
let planprices;
let discountPrices = 0;

const UpdateSubModal = ({
  form,
  isModalOpen,
  setIsModalOpen,
  onFinish,
  loadings,
  endUserDetail,
  isPlanListEmpty,
  setIsPlanListEmpty,
  cardPrice,
  setCardPrice,
  planMembership,
  setPlanMembership,
  planSecurityDeposit,
  setPlanSecurityDeposit,
  discountedPrice,
  setDiscountedPrice,
  cardPricePaid,
  setCardPricePaid,
  securityDepositPaid,
  setsecurityDepositPaid,
  membershipFeesPaid,
  setmembershipFeesPaid,
  PayableAmount,
  setPayableAmount,
  foc,
  setFoc,
}) => {
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);
  const [showTransactionId, setShowTransactionId] = useState(false);
  const disabledDate = (current) => current && current > moment().endOf('day');
  const handleCancel = () => {
    setIsModalOpen(false);
    form?.resetFields();
    setFoc('');
    setCardPrice(0);
    setPlanMembership(0);
    setPlanSecurityDeposit(0);
    setCardPricePaid(0);
    setmembershipFeesPaid(0);
    setsecurityDepositPaid(0);
    setPayableAmount(0);
    setDiscountedPrice(0);
  };

  const handlecardPricePaid = (e) => {
    setCardPricePaid(e.target.value);
  };
  const handlesecurityDepositPaid = (e) => {
    setsecurityDepositPaid(e.target.value);
  };
  const handlemembershipChargesPaid = (e) => {
    setmembershipFeesPaid(e.target.value);
  };
  const validateCardPricePaid = (_, value) =>
    new Promise((resolve, reject) => {
      if (value === null || value === undefined || value === '') {
        reject(new Error('Card price is required'));
        return;
      }
      if (parseFloat(cardPrice) === 0 && parseFloat(value) > 0) {
        reject(new Error(`Card price must be ${cardPrice}`));
      } else if (value && parseFloat(value) > cardPrice) {
        reject(
          new Error(`Card price must be less than or equal to  ${cardPrice}`),
        );
      } else {
        resolve();
      }
    });
  const validatemembershipFeesPaid = (_, value) =>
    new Promise((resolve, reject) => {
      if (value === null || value === undefined || value === '') {
        reject(new Error('`Membership Charges is required'));
        return;
      }
      if (value && parseFloat(planMembership) === 0 && parseFloat(value) > 0) {
        reject(new Error(`Membership Charges must be ${planMembership}`));
      } else if (value && parseFloat(value) > planMembership) {
        reject(
          new Error(
            `Membership Charges must be less than or equal to ${planMembership}`,
          ),
        );
      } else {
        resolve();
      }
    });
  const validatesecurityDepositPaid = (_, value) =>
    new Promise((resolve, reject) => {
      if (value === null || value === undefined || value === '') {
        reject(new Error('`Security deposit is required'));
        return;
      }
      if (parseFloat(planSecurityDeposit) === 0 && parseFloat(value) > 0) {
        reject(new Error(`Security deposit must be ${planSecurityDeposit}`));
      } else if (value && parseFloat(value) > planSecurityDeposit) {
        reject(
          new Error(
            `Security deposit must be less than or equal to  ${planSecurityDeposit}`,
          ),
        );
      } else {
        resolve();
      }
    });
  const handleModeOfPaymentChange = (value) => {
    setShowTransactionId(value !== 'cash');
  };
  const handleFOC = (value) => {
    setFoc(value);
  };
  const submitForm = () =>
    new Promise(() => {
      form.submit();
    });
  const handleUpgradeSubscription = async () => {
    await submitForm();
    setFoc('');
    setCardPrice(0);
    setPlanMembership(0);
    setPlanSecurityDeposit(0);
    setCardPricePaid(0);
    setmembershipFeesPaid(0);
    setsecurityDepositPaid(0);
    setPayableAmount(0);
    setDiscountedPrice(0);
  };
  useEffect(() => {
    discountPrices =
      parseInt(cardPrice || 0, 10) -
      parseInt(cardPricePaid || 0, 10) +
      (parseInt(planMembership || 0, 10) -
        parseInt(membershipFeesPaid || 0, 10)) +
      (parseInt(planSecurityDeposit || 0, 10) -
        parseInt(securityDepositPaid || 0, 10));

    if (form.getFieldValue().paid === 'foc') {
      setTimeout(() => {
        setPayableAmount(0);
        setCardPricePaid(0);
        setmembershipFeesPaid(0);
        setsecurityDepositPaid(0);
        form?.setFieldsValue({
          payableAmount: 0,
          securityDeposit: 0,
          membershipCharges: 0,
          modeOfPayment: 'other',
          transactionId: 'NA',
          discount: 0,
          pricePaid: 0,
          securityDepositPaid: 0,
          membershipChargesPaid: 0,
        });
      }, 300);
    }

    const initialValueFun = () => {
      form?.setFieldsValue({
        price: cardPrice,
        paid: foc,
        membershipCharges: planMembership,
        securityDeposit: planSecurityDeposit,
        totalDiscount: discountedPrice,
        payableAmount: PayableAmount,
      });
    };
    setDiscountedPrice(discountPrices);
    setPayableAmount(
      parseInt(cardPricePaid || 0, 10) +
        parseInt(membershipFeesPaid || 0, 10) +
        parseInt(securityDepositPaid || 0, 10),
    );
    setTimeout(initialValueFun, 300);
  }, [
    cardPrice,
    discountPrices,
    planprices,
    cardPricePaid,
    membershipFeesPaid,
    securityDepositPaid,
    planMembership,
    planSecurityDeposit,
    discountedPrice,
    form.getFieldValue(),
  ]);
  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleUpgradeSubscription}
        title="Update Subscription"
        okText="Save"
        confirmLoading={loadings}
        destroyOnClose
        forceRender
      >
        <Divider />
        <div className="mb-16">
          <Form
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
            onFinishFailed={() => setIsValidateTrigger(true)}
          >
            <Item
              label="Plan"
              name="plan"
              rules={[{ required: true, message: 'Please Select Plan!' }]}
            >
              <SubscriptionPlanSelect
                type={SUBSCRIPTION_TYPE?.UPDATE_SUB?.value}
                planData={endUserDetail?.subscriptionPlan}
                isPlanListEmpty={isPlanListEmpty}
                setIsPlanListEmpty={setIsPlanListEmpty}
                onChange={(_, option) => {
                  setCardPrice(option?.price);
                  setPlanMembership(
                    option?.data?.subscriptionFeatures?.memberShipFees,
                  );
                  setPlanSecurityDeposit(
                    option?.data?.subscriptionFeatures?.refundableDeposit,
                  );
                }}
              />
            </Item>
            <Item
              label="FOC / Paid"
              name="paid"
              rules={[{ required: true, message: 'Please select FOC/Paid' }]}
            >
              <Select
                placeholder="please select"
                allowClear
                onChange={handleFOC}
              >
                <Option value="foc">FOC</Option>
                <Option value="paid">Paid</Option>
              </Select>
            </Item>

            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <Item label="Plan Price" name="price">
                  <Input
                    placeholder="Plan Price"
                    value={cardPrice.toString()}
                    disabled
                  />
                </Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <Item label="Security deposit" name="securityDeposit">
                  <NumberComponent
                    allowClear
                    placeholder="Enter Security deposit"
                    type={NUMBER_FIELD_TYPES?.PRICE}
                    disabled
                  />
                  {/* <InputNumber
                min={1}
                precision={0}
                style={{ width: '100%' }}
                placeholder="Enter Security deposit"
                parser={(value) => value.replace(/\D/g, '')}
                formatter={(value) => `${value}`}
              /> */}
                </Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <Item label="Membership Charges" name="membershipCharges">
                  {/* <InputNumber
                min={1}
                precision={0}
                style={{ width: '100%' }}
                placeholder="Enter Membership Charges"
                parser={(value) => value.replace(/\D/g, '')}
                formatter={(value) => `${value}`}
              /> */}
                  <NumberComponent
                    allowClear
                    placeholder="Enter Membership Charges"
                    type={NUMBER_FIELD_TYPES?.PRICE}
                    disabled
                  />
                </Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <Item
                  label="Plan Price"
                  name="pricePaid"
                  rules={[{ validator: validateCardPricePaid }]}
                >
                  <Input
                    onChange={handlecardPricePaid}
                    placeholder="Plan Price"
                  />
                </Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <Item
                  label="Security deposit"
                  name="securityDepositPaid"
                  rules={[{ validator: validatesecurityDepositPaid }]}
                >
                  {/* <InputNumber
                min={1}
                precision={0}
                style={{ width: '100%' }}
                placeholder="Enter Security Deposit"
                parser={(value) => value.replace(/\D/g, '')}
                formatter={(value) => `${value}`}
              /> */}
                  <NumberComponent
                    allowClear
                    placeholder="Enter Security deposit"
                    type={NUMBER_FIELD_TYPES?.PRICE}
                    onChange={handlesecurityDepositPaid}
                  />
                </Item>
              </Col>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <Item
                  label="Membership Charges"
                  name="membershipChargesPaid"
                  rules={[{ validator: validatemembershipFeesPaid }]}
                >
                  {/* <InputNumber
                min={1}
                precision={0}
                style={{ width: '100%' }}
                placeholder="Enter Membership Charges"
                parser={(value) => value.replace(/\D/g, '')}
                formatter={(value) => `${value}`}
              /> */}
                  <NumberComponent
                    allowClear
                    placeholder="Enter Membership Charges"
                    type={NUMBER_FIELD_TYPES?.PRICE}
                    onChange={handlemembershipChargesPaid}
                  />
                </Item>
              </Col>
            </Row>
            <Item label="Payable amount" name="payableAmount">
              <NumberComponent
                allowClear
                placeholder="Enter Amount"
                type={NUMBER_FIELD_TYPES?.PRICE}
                value={form?.getFieldValue().paid === 'foc' ? 0 : PayableAmount}
                disabled
              />
            </Item>
            <Item label="Total Discount" name="totalDiscount">
              <Input
                placeholder="Total Discount Price"
                value={discountedPrice}
                disabled
              />
            </Item>
            <Item
              label="Mode of Payment"
              name="modeOfPayment"
              rules={[
                { required: true, message: 'Please select Mode of Payment!' },
              ]}
            >
              <Select
                placeholder="Select Mode of Payment"
                allowClear
                onChange={handleModeOfPaymentChange}
              >
                <Option value="stripe">Stripe</Option>
                <Option value="razorpay">Razorpay</Option>
                <Option value="phonepe">PhonePe</Option>
                <Option value="upi">UPI</Option>
                <Option value="pos">POS</Option>
                <Option value="cash">Cash</Option>
                <Option value="other">Other</Option>
              </Select>
            </Item>

            {showTransactionId && (
              <Item
                label="Transaction ID"
                name="transactionId"
                rules={[
                  { required: true, message: 'Please Enter Transaction ID!' },
                ]}
              >
                <Input placeholder="Enter Transaction ID" />
              </Item>
            )}
            <Item
              label="Payment Date"
              name="activatedAt"
              rules={[
                { required: true, message: 'Please Enter Payment Date!' },
              ]}
            >
              <DatePicker
                format={DATE_FORMATS?.REGULAR}
                placeholder="Select Payment Date"
                className="subscription-date-picker"
                popupClassName="picker-with-scroll"
                disabledDate={disabledDate}
              />
            </Item>
            <Item name="note" label="Note" rules={[whitespaceNotAllowed]}>
              <TextArea
                rows={3}
                allowClear
                placeholder="Enter Note"
                showCount
                maxLength={700}
              />
            </Item>
          </Form>
        </div>
      </ModalComponent>
    </>
  );
};

export default UpdateSubModal;
